import React from 'react';
import moment from 'moment';
import PostInfoInjector from '../PostInfoInjector';

const PostCreateDateViewer = ({
  postInfo,
  dateFormat = 'YYYY-MM-DD HH:mm:ss',
  className = '',
}) => {
  let createDate = '';
  if (postInfo) {
    createDate = moment(postInfo.created_date).format(dateFormat);
  }

  return <span className={className}>{createDate}</span>;
};

export default PostInfoInjector()(PostCreateDateViewer);
